import type { Comic, Category } from '@/types/comic';

export const categories: Category[] = [
  { id: 1, slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { id: 2, slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { id: 3, slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { id: 4, slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { id: 5, slug: 'comedy', name: '喜剧', icon: 'ri-emotion-happy-line' },
  { id: 6, slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { id: 7, slug: 'school', name: '校园', icon: 'ri-building-line' },
  { id: 8, slug: 'office', name: '职场', icon: 'ri-briefcase-line' },
  { id: 9, slug: 'historical', name: '古风', icon: 'ri-history-line' },
  { id: 10, slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    slug: 'my-lovely-secretary',
    title: '我的可爱秘书',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20style%2C%20beautiful%20woman%20in%20office%20attire%2C%20soft%20warm%20lighting%2C%20clean%20illustration%20with%20gentle%20expressions%2C%20Korean%20webtoon%20aesthetic%20with%20soft%20pastel%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '平凡的公司职员李智恩，意外成为了冷酷总裁的私人秘书。在日复一日的相处中，她逐渐发现总裁不为人知的温柔一面。一段办公室里的甜蜜爱情故事即将展开...',
    category: 'romance',
    tags: ['恋爱', '职场', '甜蜜'],
    status: '连载中',
    rating: 9.2,
    views: 1520000,
    updatedAt: '2026-08-04',
    chapters: 87,
    chapterList: [
      { id: 1, number: 87, title: '意外的告白', date: '2026-08-04' },
      { id: 2, number: 86, title: '雨中的相遇', date: '2026-08-01' },
      { id: 3, number: 85, title: '心跳加速', date: '2026-07-28' },
      { id: 4, number: 84, title: '秘密约会', date: '2026-07-25' },
      { id: 5, number: 83, title: '误会解除', date: '2026-07-22' },
    ],
  },
  {
    id: 2,
    slug: 'solo-leveling-shadow',
    title: '我独自升级：暗影君王',
    author: '张成浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20comic%20cover%2C%20dark%20warrior%20with%20shadow%20powers%2C%20dramatic%20lighting%2C%20intense%20action%20scene%2C%20Korean%20webtoon%20style%20with%20dark%20blue%20and%20black%20tones&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在一个怪物横行的世界里，最弱猎人成振宇在一次生死危机中觉醒了"系统"能力。从此踏上成为最强猎人的征途，不断升级突破极限！',
    category: 'action',
    tags: ['动作', '奇幻', '升级'],
    status: '连载中',
    rating: 9.8,
    views: 8920000,
    updatedAt: '2026-08-03',
    chapters: 198,
    chapterList: [
      { id: 6, number: 198, title: '最终决战前夕', date: '2026-08-03' },
      { id: 7, number: 197, title: '觉醒的力量', date: '2026-07-31' },
      { id: 8, number: 196, title: '暗影军团集结', date: '2026-07-28' },
      { id: 9, number: 195, title: '王者降临', date: '2026-07-25' },
      { id: 10, number: 194, title: '突破极限', date: '2026-07-22' },
    ],
  },
  {
    id: 3,
    slug: 'destined-to-meet-you',
    title: '命中注定遇见你',
    author: '李恩珠',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20comic%20cover%2C%20ethereal%20woman%20with%20long%20flowing%20hair%2C%20magical%20sparkles%2C%20dreamy%20atmosphere%2C%20Korean%20webtoon%20style%20with%20soft%20pink%20and%20gold%20tones&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '穿越到异世界的普通女大学生，发现自己竟然是预言中的天命之女。三位王国王子都对她展开了热烈追求，她该如何抉择？',
    category: 'fantasy',
    tags: ['奇幻', '恋爱', '穿越'],
    status: '已完结',
    rating: 9.5,
    views: 3210000,
    updatedAt: '2026-07-15',
    chapters: 120,
    chapterList: [
      { id: 11, number: 120, title: '永恒的约定（最终回）', date: '2026-07-15' },
      { id: 12, number: 119, title: '最后的抉择', date: '2026-07-12' },
      { id: 13, number: 118, title: '真心的告白', date: '2026-07-09' },
      { id: 14, number: 117, title: '命运交织', date: '2026-07-06' },
      { id: 15, number: 116, title: '王国危机', date: '2026-07-03' },
    ],
  },
  {
    id: 4,
    slug: 'demon-lord-reborn',
    title: '重生之魔尊归来',
    author: '朴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20dark%20fantasy%20comic%20cover%2C%20powerful%20demon%20lord%20with%20glowing%20eyes%2C%20dark%20aura%2C%20menacing%20atmosphere%2C%20Korean%20webtoon%20style%20with%20deep%20red%20and%20black%20tones&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '被挚友背叛而死的魔尊，意外重生回到五百年前。带着前世记忆的他，决定改写命运，向所有背叛者复仇！',
    category: 'action',
    tags: ['动作', '奇幻', '重生', '复仇'],
    status: '连载中',
    rating: 9.3,
    views: 4100000,
    updatedAt: '2026-08-04',
    chapters: 156,
    chapterList: [
      { id: 16, number: 156, title: '黑暗降临', date: '2026-08-04' },
      { id: 17, number: 155, title: '复仇的火焰', date: '2026-08-01' },
      { id: 18, number: 154, title: '昔日旧友', date: '2026-07-29' },
      { id: 19, number: 153, title: '力量觉醒', date: '2026-07-26' },
      { id: 20, number: 152, title: '陷阱', date: '2026-07-23' },
    ],
  },
  {
    id: 5,
    slug: 'spring-days-of-campus',
    title: '春日校园',
    author: '崔美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20comic%20cover%2C%20two%20students%20under%20cherry%20blossoms%2C%20youthful%20and%20fresh%20atmosphere%2C%20Korean%20webtoon%20style%20with%20soft%20pink%20and%20green%20tones&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '转学生韩智浩来到了春川高中，在这里他遇见了活泼开朗的班长金多美。樱花树下，一段纯真的校园恋爱故事悄然绽放。',
    category: 'school',
    tags: ['校园', '恋爱', '青春'],
    status: '连载中',
    rating: 8.9,
    views: 980000,
    updatedAt: '2026-08-02',
    chapters: 63,
    chapterList: [
      { id: 21, number: 63, title: '樱花下的约定', date: '2026-08-02' },
      { id: 22, number: 62, title: '学园祭前夕', date: '2026-07-30' },
      { id: 23, number: 61, title: '心跳的瞬间', date: '2026-07-27' },
      { id: 24, number: 60, title: '雨天的回忆', date: '2026-07-24' },
      { id: 25, number: 59, title: '图书馆的秘密', date: '2026-07-21' },
    ],
  },
  {
    id: 6,
    slug: 'behind-the-mask',
    title: '面具背后',
    author: '姜东元',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20mystery%20comic%20cover%2C%20mysterious%20figure%20in%20shadow%2C%20suspenseful%20atmosphere%2C%20dark%20alley%2C%20Korean%20webtoon%20style%20with%20dark%20gray%20and%20crimson%20tones&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '一名连环杀手在首尔街头出没，警方束手无策。犯罪心理学家李瑞妍被邀请协助调查，却发现自己与案件有着千丝万缕的联系...',
    category: 'thriller',
    tags: ['悬疑', '犯罪', '心理'],
    status: '连载中',
    rating: 9.1,
    views: 2100000,
    updatedAt: '2026-08-03',
    chapters: 92,
    chapterList: [
      { id: 26, number: 92, title: '真相浮现', date: '2026-08-03' },
      { id: 27, number: 91, title: '最后的面具', date: '2026-07-31' },
      { id: 28, number: 90, title: '追捕', date: '2026-07-28' },
      { id: 29, number: 89, title: '新的线索', date: '2026-07-25' },
      { id: 30, number: 88, title: '暗流涌动', date: '2026-07-22' },
    ],
  },
  {
    id: 7,
    slug: 'office-survival-guide',
    title: '职场生存指南',
    author: '尹智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20comedy%20comic%20cover%2C%20young%20woman%20in%20modern%20office%2C%20humorous%20expression%2C%20bright%20and%20clean%20illustration%2C%20Korean%20webtoon%20style%20with%20warm%20beige%20and%20blue%20tones&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '刚毕业的菜鸟金泰熙进入大公司，面对各种奇葩同事和无理上司，她用幽默和智慧在职场中闯出一片天地！',
    category: 'comedy',
    tags: ['喜剧', '职场', '日常'],
    status: '已完结',
    rating: 8.7,
    views: 1780000,
    updatedAt: '2026-06-20',
    chapters: 80,
    chapterList: [
      { id: 31, number: 80, title: '新的开始（最终回）', date: '2026-06-20' },
      { id: 32, number: 79, title: '升职之路', date: '2026-06-17' },
      { id: 33, number: 78, title: '团队合作', date: '2026-06-14' },
      { id: 34, number: 77, title: '危机处理', date: '2026-06-11' },
      { id: 35, number: 76, title: '竞标大战', date: '2026-06-08' },
    ],
  },
  {
    id: 8,
    slug: 'empress-janghua',
    title: '将军令之张皇后',
    author: '韩彩英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20comic%20cover%2C%20elegant%20queen%20in%20traditional%20hanbok%2C%20palace%20background%2C%20dramatic%20mood%2C%20Korean%20webtoon%20style%20with%20rich%20gold%20and%20deep%20red%20tones&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '出身武将世家的张氏，被选入宫中成为皇后。在尔虞我诈的后宫中，她凭借智慧和勇气，一步步走向权力巅峰。',
    category: 'historical',
    tags: ['古风', '宫斗', '权谋'],
    status: '连载中',
    rating: 9.4,
    views: 2670000,
    updatedAt: '2026-08-01',
    chapters: 145,
    chapterList: [
      { id: 36, number: 145, title: '凤临天下', date: '2026-08-01' },
      { id: 37, number: 144, title: '暗潮汹涌', date: '2026-07-29' },
      { id: 38, number: 143, title: '朝堂风云', date: '2026-07-26' },
      { id: 39, number: 142, title: '后宫之争', date: '2026-07-23' },
      { id: 40, number: 141, title: '密谋', date: '2026-07-20' },
    ],
  },
  {
    id: 9,
    slug: 'whispers-in-the-dark',
    title: '暗夜低语',
    author: '宋志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20supernatural%20comic%20cover%2C%20ghostly%20figure%20in%20darkness%2C%20haunting%20expression%2C%20eerie%20mood%2C%20Korean%20webtoon%20style%20with%20dark%20green%20and%20black%20tones&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '搬进老旧公寓的大学生，每晚都听到奇怪的耳语声。随着调查深入，他发现这座公寓隐藏着令人毛骨悚然的秘密...',
    category: 'horror',
    tags: ['恐怖', '灵异', '悬疑'],
    status: '连载中',
    rating: 8.8,
    views: 1340000,
    updatedAt: '2026-08-02',
    chapters: 71,
    chapterList: [
      { id: 41, number: 71, title: '地下室的秘密', date: '2026-08-02' },
      { id: 42, number: 70, title: '消失的邻居', date: '2026-07-30' },
      { id: 43, number: 69, title: '深夜访客', date: '2026-07-27' },
      { id: 44, number: 68, title: '302号房', date: '2026-07-24' },
      { id: 45, number: 67, title: '不该打开的门', date: '2026-07-21' },
    ],
  },
  {
    id: 10,
    slug: 'love-in-paris',
    title: '巴黎恋人',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20comic%20cover%2C%20couple%20in%20Paris%20with%20Eiffel%20Tower%20background%2C%20romantic%20mood%2C%20Korean%20webtoon%20style%20with%20warm%20golden%20and%20rose%20tones&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '设计师朴秀雅来到巴黎进修，在塞纳河畔邂逅了神秘的钢琴师。异国他乡的浪漫爱情，跨越语言与文化的界限。',
    category: 'romance',
    tags: ['恋爱', '异国', '浪漫'],
    status: '已完结',
    rating: 9.0,
    views: 2450000,
    updatedAt: '2026-05-30',
    chapters: 96,
    chapterList: [
      { id: 46, number: 96, title: '巴黎之夜（最终回）', date: '2026-05-30' },
      { id: 47, number: 95, title: '告白', date: '2026-05-27' },
      { id: 48, number: 94, title: '抉择', date: '2026-05-24' },
      { id: 49, number: 93, title: '误会', date: '2026-05-21' },
      { id: 50, number: 92, title: '塞纳河畔', date: '2026-05-18' },
    ],
  },
  {
    id: 11,
    slug: 'sword-of-destiny',
    title: '天命之剑',
    author: '张成浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20comic%20cover%2C%20swordsman%20with%20legendary%20weapon%2C%20epic%20landscape%2C%20heroic%20mood%2C%20Korean%20webtoon%20style%20with%20silver%20and%20sky%20blue%20tones&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '平凡少年意外拔出传说中的天命之剑，成为拯救世界的天选之人。踏上冒险之旅，结识伙伴，对抗黑暗势力！',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '少年'],
    status: '连载中',
    rating: 9.6,
    views: 5100000,
    updatedAt: '2026-08-04',
    chapters: 178,
    chapterList: [
      { id: 51, number: 178, title: '龙之战', date: '2026-08-04' },
      { id: 52, number: 177, title: '圣域之门', date: '2026-08-01' },
      { id: 53, number: 176, title: '最后的试炼', date: '2026-07-29' },
      { id: 54, number: 175, title: '伙伴的力量', date: '2026-07-26' },
      { id: 55, number: 174, title: '黑暗降临', date: '2026-07-23' },
    ],
  },
  {
    id: 12,
    slug: 'my-boss-is-a-cat',
    title: '我的上司是猫',
    author: '崔美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20fantasy%20comic%20cover%2C%20cute%20cat%20in%20business%20suit%2C%20office%20setting%2C%20playful%20and%20warm%20atmosphere%2C%20Korean%20webtoon%20style%20with%20soft%20orange%20and%20cream%20tones&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '普通上班族李敏浩发现自己的上司其实是一只会说话的猫！为了守住这个秘密，他和上司之间展开了一段爆笑又温馨的职场日常。',
    category: 'comedy',
    tags: ['喜剧', '职场', '治愈'],
    status: '连载中',
    rating: 8.6,
    views: 890000,
    updatedAt: '2026-08-01',
    chapters: 54,
    chapterList: [
      { id: 56, number: 54, title: '猫咪的秘密', date: '2026-08-01' },
      { id: 57, number: 53, title: '公司派对', date: '2026-07-29' },
      { id: 58, number: 52, title: '出差日记', date: '2026-07-26' },
      { id: 59, number: 51, title: '新同事', date: '2026-07-23' },
      { id: 60, number: 50, title: '午休时间', date: '2026-07-20' },
    ],
  },
];

export const featuredComicIds = [2, 1, 11, 3, 8, 4];

export const hotComicIds = [2, 11, 3, 8, 4, 1, 10, 6];

export const latestComicIds = [1, 4, 11, 6, 2, 9, 5, 8, 12, 10, 3, 7];